<template>
  <div class="container">
    <content-header :data="[{text:'测试统计', path: ''}]"></content-header>
    <div class="content">
      <div class="content-bar">
        <div class="search-entry">
            <el-input
              placeholder="关键词"
              v-model="keywords">
            </el-input>
        </div>
        <div class="search-btn">
          <el-button type="primary" @click="searchHandle">查询</el-button>
        </div>
      </div>
      <!-- 列表区域 -->
      <div class="content-list">
        <el-table
          :data="tableData"
          border
          stripe>
          <el-table-column
            prop="test_name"
            label="测试名称"
            width="150"
            fixed
            >
          </el-table-column>
          <el-table-column
            prop="start_time"
            label="开始时间"
            width="100">
          </el-table-column>
          <el-table-column
            prop="end_time"
            label="结束时间"
            width="100">
          </el-table-column>
          <el-table-column
            prop="question_count"
            label="题目数">
          </el-table-column>
          <el-table-column
            prop="user_count"
            label="参与人数">
          </el-table-column>
          <el-table-column
            prop="pass_rate"
            label="通过率">
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            width="150">
            <template slot-scope="scope">
              <el-button @click="viewHandle(scope)" type="text" size="small" >查看明细</el-button>
              <el-button @click="exportHandle(scope)" type="text" size="small" >导出明细</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination" v-if="total > pageSize">
          <el-pagination
            @size-change="pageSizeChange"
            @current-change="curPageChange"
            :current-page="curPage"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
  import TestModel from 'models/test'

  export default {
    components: {
    },
    data () {
      return {
        keywords: '',
        tableData: [],
        curPage: 1,
        pageSize: 10,
        total: 0
      }
    },
    created () {
      //
      this.getObjList()
    },
    methods: {
      pageSizeChange (size) {
        this.pageSize = size
        this.getObjList()
      },
      curPageChange (page) {
        this.curPage = page
        this.getObjList()
      },
      getObjList (opts) {
        const _opts = {
          curPage: this.curPage,
          pageSize: this.pageSize,
          keywords: this.keywords
        }
        // 合并参数
        if (typeof opts === 'object') Object.assign(_opts, opts)
        console.log(_opts)
        //
        TestModel.getTestResult(_opts).then(res => {
          this.tableData = res.item_list
          this.total = res.total
        })
      },
      //
      viewHandle (item) {
        this.$router.push({
          name: 'test.result.detail',
          query: {id: item.row.test_id}
        })
      },
      searchHandle () {
        this.getObjList()
      },
      //
      exportHandle (item) {
        TestModel.exportTestResultDetail({test_id: item.row.test_id})
      },
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.container
  min-height: 100%
  background-color: #fff
  .content
    .content-bar
      padding: 20px
      .search-entry
        display: inline-block
        vertical-align: top
        margin-right: 10px
        margin-bottom: 10px
      .search-btn
        display: inline-block
        vertical-align: top
    .content-list
      padding-left: 20px
      padding-right: 20px
      padding-bottom: 40px
      .pagination
        margin-top: 10px
    .new-wrap
      .el-input
        width: 300px
      .form-title
        padding-top: 10px
        padding-bottom: 10px
        font-size: 12px
        color: #aaa
    .avatar-uploader
        border: 1px dashed #d9d9d9
        border-radius: 6px
        cursor: pointer
        position: relative
        overflow: hidden
        width: 180px
        &:hover
          border-color: #409EFF
        .avatar-uploader-icon
          font-size: 28px
          color: #8c939d
          width: 178px
          height: 178px
          line-height: 178px
          text-align: center
        .avatar
          width: 178px
          height: 178px
          display: block

</style>



// WEBPACK FOOTER //
// src/views/TestResult.vue